import { z } from 'zod';
import { apiGet, demoMode } from './api';
import { demoServices, demoStaff } from './demo';

export const ServiceSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  price: z.number().int().nonnegative(),
  duration_min: z.number().int().positive(),
  description: z.string().nullable(),
  popular: z.boolean()
});

export type Service = z.infer<typeof ServiceSchema>;

export async function fetchServices(_tenantId: string): Promise<Service[]> {
  if (demoMode) {
    return z.array(ServiceSchema).parse(demoServices());
  }

  const data = await apiGet<unknown>('/services');
  return z.array(ServiceSchema).parse(data);
}

export const StaffSchema = z.object({
  id: z.string(),
  name: z.string(),
  role: z.string().nullable().optional()
});

export type Staff = z.infer<typeof StaffSchema>;

// Мастера, которые делают выбранную услугу.
export async function fetchStaff(_tenantId: string, serviceId: string): Promise<Staff[]> {
  if (demoMode) {
    return z.array(StaffSchema).parse(demoStaff(serviceId));
  }

  const data = await apiGet<unknown>(
    `/staff?serviceId=${encodeURIComponent(serviceId)}`
  );
  return z.array(StaffSchema).parse(data);
}
